/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

// Images
import post1 from "assets/images/homme-vitres.jpg";
import post2 from "assets/images/femme-cuisine.jpg";
import post3 from "assets/images/hommes.jpg";
import post4 from "assets/images/jeune-homme.jpg";

function Places() {
  return (
    <MKBox component="section" py={2}>
      {/* <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            Check my latest blogposts
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post1}
              title="Rover raised $65 million"
              description="Finding temporary housing for your dog should be as easy as renting an Airbnb. That’s the idea behind Rover ..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "read more",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post2}
              title="MateLabs machine learning"
              description="If you’ve ever wanted to train a machine learning model and integrate it with IFTTT, you now can with ..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "read more",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post3}
              title="MateLabs machine learning"
              description="If you’ve ever wanted to train a machine learning model and integrate it with IFTTT, you now can with ..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "read more",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BackgroundBlogCard
              image={post4}
              title="Flexible work hours"
              description="Rather than worrying about switching offices every couple years, you stay in the same place."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                label: "read more",
              }}
            />
          </Grid>
        </Grid>
      </Container> */}
      <Container>
  <Grid container item xs={12} lg={6}>
    <MKTypography variant="h3" mb={6}>
      Nos services de nettoyage
    </MKTypography>
  </Grid>
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6} lg={3}>
      <TransparentBlogCard
        image={post1}
        title="Nettoyage de bureaux"
        description="Assurez un espace de travail propre et sain pour vos employés avec nos services de nettoyage professionnels."
        action={{
          // type: "internal",
          // route: "/services/nettoyage-bureaux",
          color: "info",
          // label: "En savoir plus",
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6} lg={3}>
      <TransparentBlogCard
        image={post2}
        title="Entretien des maisons"
        description="Profitez d'une maison impeccable grâce à nos prestations de nettoyage adaptées à vos besoins."
        action={{
          // type: "internal",
          // route: "/services/nettoyage-maison",
          color: "info",
          // label: "En savoir plus",
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6} lg={3}>
      <TransparentBlogCard
        image={post3}
        title="Nettoyage après travaux"
        description="Nous assurons un nettoyage minutieux après vos rénovations pour un intérieur impeccable et sans poussière."
        action={{
          // type: "internal",
          // route: "/services/nettoyage-travaux",
          color: "info",
          // label: "En savoir plus",
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6} lg={3}>
      <BackgroundBlogCard
        image={post4}
        title="Intervention flexible"
        description="Nous nous adaptons à vos horaires pour un service efficace, discret et professionnel."
        action={{
          // type: "internal",
          // route: "/services/intervention-flexible",
          // label: "En savoir plus",
        }}
      />
    </Grid>
  </Grid>
</Container>

    </MKBox>
  );
}

export default Places;
